import { theme } from '../Theme';
import { css } from 'emotion';

export const EztradStyling = css`
  .items-container .column {
    .heading-container {
      h2 {
        color: ${theme.colors.almostBlack};
      }
      .subtitle {
        color: ${theme.colors.almostBlack};
      }
    }
    .info-item h3 {
      font-weight: 700;
      font-size: 0.875rem;

      text-transform: uppercase;
      font-variant: normal;
    }
    .store-link {
      text-decoration: none;
      border: none;
      border-bottom: none;
      padding: 0 0 3px;
      font-weight: 700;
      font-size: 0.875rem;
      letter-spacing: 0.03em;
      font-feature-settings: 'liga' off;
      font-variant: normal;
      text-transform: none;
      color: ${theme.colors.almostBlack};
    }
  }
`;
